import React from "react";
import { Settings } from "lucide-react";
import { useSelector } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { isStaffEmail } from "@utils/user_utils";

interface ChatHeaderProps {
    settingsOpen: boolean;
    onSettingsToggle: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({ settingsOpen, onSettingsToggle }) => {
    const { team_logo } = useSelector(({ team }: any) => team?.info ?? {});
    const { user } = useAuth0();
    const isStaff = isStaffEmail(user?.email);

    return (
        <div className="chat-v2-header-wrapper">
            <div className="chat-v2-header">
                <div className="chat-v2-header-logo">
                    {team_logo && (
                        <img src={team_logo} alt="Team logo" className="chat-v2-header-team-logo" />
                    )}
                </div>
                <div className="chat-v2-header-title-block">
                    <span className="chat-v2-header-title">Whistle AI</span>
                    <span className="chat-v2-header-subtitle">Talk to your data</span>
                </div>
                {isStaff && (
                    <button
                        className={`chat-v2-header-gear-btn ${settingsOpen ? "active" : ""}`}
                        onClick={onSettingsToggle}
                        aria-label="Settings"
                    >
                        <Settings size={18} />
                    </button>
                )}
            </div>
        </div>
    );
};

export default ChatHeader;
